import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2994d18a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "home_main" }
const _hoisted_3 = {
  key: 0,
  class: "angelleague_login"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_20B" }, [
  /*#__PURE__*/_createTextVNode(" 비상장 스타트업"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 정보공유 커뮤니티 ")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 엔젤리그 로그인 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "right-btn",
  src: "/assets/icon/btn_right_b.png",
  srcset: "/assets/icon/btn_right_b@2x.png 2x,/assets/icon/btn_right_b@3x.png 3x"
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "home_intro" }
const _hoisted_9 = { class: "intro_btns space-between" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" (주)엔젤리그 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 대표이사 오현석 / support@capbox.kr")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 서울특별시 강남구 선릉로 158길 7, 4층(청담동)")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 사업자 등록번호 705-87-01352")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 통신판매번호 2021-서울강남-03485")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Copyright © Angel League, Inc. All rights reserved.")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_sellRegistModal = _resolveComponent("sellRegistModal")!
  const _component_stake_lists_modal = _resolveComponent("stake-lists-modal")!
  const _component_individual_info = _resolveComponent("individual-info")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_nft_banner_mid = _resolveComponent("nft-banner-mid")!
  const _component_home_board_list = _resolveComponent("home-board-list")!
  const _component_link_account_modal = _resolveComponent("link-account-modal")!
  const _component_regist_sell_stake_modal = _resolveComponent("regist-sell-stake-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { ref: "mainElement" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.user === null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", {
                      class: "login_btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'로그인', 'clickContent':'엔젤리그로그인'});_ctx.$global.openLoginModal();})
                    }, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_sellRegistModal, {
                "is-open": _ctx.sellModalOpen,
                onClose: _cache[1] || (_cache[1] = () => _ctx.sellModalOpen = false)
              }, null, 8, ["is-open"]),
              _createVNode(_component_stake_lists_modal, {
                "is-open": _ctx.stakeListOpen,
                onClose: _cache[2] || (_cache[2] = () => _ctx.stakeListOpen = false)
              }, null, 8, ["is-open"])
            ]),
            _createVNode(_component_ag_box_s, { css: {px: 20, pb: 20} }, {
              default: _withCtx(() => [
                (_ctx.user)
                  ? (_openBlock(), _createBlock(_component_individual_info, {
                      key: 0,
                      name: _ctx.user.name,
                      "invest-amount": _ctx.totalAsset,
                      "invest-profit": _ctx.totalIncomingProfit,
                      "refresh-date": _ctx.reflectAt,
                      "profit-rate": _ctx.totalIncomingProfitRate
                    }, null, 8, ["name", "invest-amount", "invest-profit", "refresh-date", "profit-rate"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_nft_banner_mid),
            _createVNode(_component_home_board_list, {
              "stock-item-boards-prop": _ctx.stockItemBoards,
              parent: "home"
            }, null, 8, ["stock-item-boards-prop"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "navy_btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'서비스 소개', 'clickContent':'1:1 문의'});_ctx.openChannelTalk()})
                }, " 1:1 문의 ")
              ])
            ]),
            _createVNode(_component_ag_box_s, { css: {p: '32px 20px', bg: 'gray6', lineHeight: '20px'} }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {typography: 'main12r', color: 'gray2'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography: 'tit14b', color: 'gray2', mb: 4} }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {dp: 'black', typography: 'main12r', color: 'gray2', mt:16} }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {typography: 'main12r', color: 'gray2', fontWeight: '700', mt:16} }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'FAQ'});_ctx.openFAQModal('FAQ')})
                    }, "FAQ "),
                    _hoisted_22,
                    _createElementVNode("span", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'회사소개'});_ctx.openFAQModal('info')})
                    }, " 회사소개 "),
                    _hoisted_23,
                    _createElementVNode("span", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'이용약관'});_ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')})
                    }, " 이용약관 "),
                    _hoisted_24,
                    _createElementVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'개인정보처리방침'});_ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')})
                    }, " 개인정보처리방침 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_link_account_modal, {
            "model-value": _ctx.linkAccountModal,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = (value) => _ctx.linkAccountModal = value),
            onComplete: _ctx.afterLinkAccountAct
          }, null, 8, ["model-value", "onComplete"]),
          _createVNode(_component_regist_sell_stake_modal, {
            "open-type": _ctx.SellOpenType,
            "is-open": _ctx.stakeSellOpen,
            onCloseWithResult: _ctx.branchResult,
            onClose: _cache[9] || (_cache[9] = () => _ctx.stakeSellOpen = false)
          }, null, 8, ["open-type", "is-open", "onCloseWithResult"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}